import React, { useState } from 'react';
import { contactAPI } from '../services/api';
import { FiX } from 'react-icons/fi';
import '../styles/ContactForm.css';

const ContactForm = ({ sessionId, onSubmit, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    productQuery: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    try {
      const response = await contactAPI.submitForm({
        ...formData,
        sessionId
      });

      if (response.success) {
        onSubmit();
      } else if (response.errors && response.errors.length > 0) {
        const message = response.errors
          .map(err => err.message)
          .filter(Boolean)
          .join(' ');
        setError(message || 'Please fix the highlighted fields and try again.');
      } else {
        setError(response.message || 'Failed to submit form. Please try again.');
      }
    } catch (err) {
      console.error('Form submission error:', err);
      setError('An error occurred. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-form-overlay">
      <div className="contact-form-container">
        <div className="contact-form-header">
          <h3>Contact Us</h3>
          <button onClick={onClose} className="close-button">
            <FiX size={20} />
          </button>
        </div>

        <p className="contact-form-description">
          We couldn't find what you're looking for. Please fill out this form and we'll get back to you soon!
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Your name *"
            />
          </div>       

          <div className="form-group">
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              placeholder="Phone number *"
            />
          </div>
           <div className="form-group">
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="your@email.com"
            />
          </div>

          <div className="form-group">
            <input
              type="text"
              id="productQuery"
              name="productQuery"
              value={formData.productQuery}
              onChange={handleChange}
              placeholder="Product you're looking for?"
            />
          </div>

          <div className="form-group">
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows="3"
              placeholder="Your message *"
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <div className="form-actions">
            <button 
              type="button" 
              onClick={onClose}
              className="cancel-button"
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button 
              type="submit"
              className="submit-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
